import React from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { AddressFields } from '../../../../common/components/ReduxFormField';
import { get, set } from 'lodash';
import PostcodeList from '../../../../common/components/Postcode/PostcodeList';
import {
  Alert,
  Box,
  Button,
  HorizontalFormControl,
  NameFields,
  Loader,
} from '../../../../common/components';
import moment from 'moment';
import DatePickerDob2 from '../../../../common/components/DatePicker/DatePickerDob2';
import Marketing from '../../../product/components/Marketing/Marketing';
import { Col, Row, Form } from 'react-bootstrap';
import { InternalButtonBar } from '../../../layout/components';

import { compose } from 'redux';
import { getCurrentBroker, isOwner } from '../../../auth/redux/authActions';

const FORM_NAME = 'customerForm';

const CustomerForm = ({
  onSaveCustomer,
  formValues,
  handleSubmit,
  submitting,
  dispatch,
  change,
}) => {
  const loggedInBroker = getCurrentBroker();
  const loggedInMetadata = loggedInBroker.data?.attributes?.metadata ?? {};
  const {
    insurance_marketing_options_enabled: isBrokerInsuranceQuestionEnabled,
    car_insurance_marketing_enabled: isBrokerCarEnabled,
    home_insurance_marketing_enabled: isBrokerHomeEnabled,
    marketing_enabled: isBrokerMarketingEnabled,
  } = loggedInMetadata;

  const isMarketingEnabled = isOwner() || !!isBrokerMarketingEnabled;
  const isInsuranceQuestionEnabled = isOwner() || !!isBrokerInsuranceQuestionEnabled;
  const isCarInsuranceQuestionEnabled = isOwner() || !!isBrokerCarEnabled;
  const isHomeInsuranceQuestionEnabled = isOwner() || !!isBrokerHomeEnabled;

  const handleMarketingOptionsChange = (options) => {
    dispatch(change('data.attributes.marketing_options', options));
  };

  if (!formValues) {
    return <Loader />;
  }

  const resource = formValues?.data?.attributes ?? {};

  return (
    <Box>
      <Form onSubmit={handleSubmit(onSaveCustomer)}>
        <Row>
          <Col sm={12}>
            <h2 className="resource-name">
              {resource
                ? `${resource.title} ${resource.first_name} ${resource.last_name}`
                : 'New customer'}
            </h2>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Alert />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NameFields
              baseName="data.attributes"
              label="Name"
              labelSize={3}
              fieldComponent={Field}
            />
          </Col>
          <Col sm={6}>
            <Field
              name={'data.attributes.dob'}
              label="Date of birth"
              showYear
              labelSize={3}
              componentSize={6}
              minDate={moment()
                .subtract(100, 'years')
                .format()}
              maxDate={moment()
                .subtract(18, 'years')
                .format()}
              component={DatePickerDob2}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Field
              name="data.attributes.email"
              label="Email"
              labelSize={3}
              component={HorizontalFormControl}
            />
          </Col>
          <Col sm={6}>
            <Field
              name="data.attributes.phone1"
              label="Phone 1"
              labelSize={3}
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Field
              name="data.attributes.phone2"
              label="Phone 2"
              labelSize={3}
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <PostcodeList
              name="data.attributes.address.postcode"
              targetField={'data.attributes.address'}
              label="Postcode"
              labelSize={3}
              postcodeFieldSize={6}
              formName={FORM_NAME}
              value={get(formValues, 'data.attributes.address.postcode', '')}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <AddressFields
              baseName="data.attributes.address"
              labelSize={3}
              smFieldSize={9}
              label="Address"
            />
          </Col>
          <Col sm={6}>
            <Marketing
              label="Marketing"
              name="data.attributes.marketing_options"
              component={Marketing}
              marketingOptions={get(formValues, 'data.attributes.marketing_options')}
              handleMarketingOptionsChange={handleMarketingOptionsChange}
              isCustomerEditPage={true}
              isMarketingEnabled={isMarketingEnabled}
              isInsuranceMarketingOptionsEnabled={isInsuranceQuestionEnabled}
              isHomeInsuranceMarketingEnabled={isHomeInsuranceQuestionEnabled}
              isCarInsuranceMarketingEnabled={isCarInsuranceQuestionEnabled}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['customer.create', 'customer.edit'],
                  button: (
                    <Button
                      className="pull-right"
                      type="submit"
                      bsStyle="primary"
                      label="Save Customer"
                      isLoading={submitting}
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </Form>
    </Box>
  );
};

const validate = (values) => {
  const errors = {};

  const requiredFields = [
    { field: 'data.attributes.address.postcode', name: 'Postcode' },
    { field: 'data.attributes.first_name', name: 'First Name' },
    { field: 'data.attributes.last_name', name: 'Last Name' },
  ];
  requiredFields.map((required) => {
    if (!get(values, required.field)) {
      set(errors, required.field, required.name + ' is required');
    }
  });
  return errors;
};

export default compose(
  connect(
    (state, props) => {
      return {
        initialValues: props.resource,
        formValues: getFormValues(FORM_NAME)(state),
      };
    },
    null,
  ),
  reduxForm({
    form: FORM_NAME,
    validate,
  }),
)(CustomerForm);
